import { ThemingConfig } from '@chakra-ui/react';

import actionButtonCardRecipe from './actionButtonCard';
import badgeRecipe from './badge';
import contentContainerRecipe from './contentContainer';
import fileUploadTileRecipe from './fileUploadTile';
import flexRecipe from './flex';
import headingRecipe from './heading';
import inputRecipe from './input';
import inputElementRecipe from './inputElement';
import layoutContainerRecipe from './layoutContainer';
import linkRecipe from './link';
import separatorRecipe from './separator';
import skeletonRecipe from './skeleton';
import spinnerRecipe from './spinner';

const basicRecipes: ThemingConfig['recipes'] = {
  actionButtonCard: actionButtonCardRecipe,
  badge: badgeRecipe,
  contentContainer: contentContainerRecipe,
  fileUploadTile: fileUploadTileRecipe,
  flex: flexRecipe,
  heading: headingRecipe,
  input: inputRecipe,
  inputElement: inputElementRecipe,
  layoutContainer: layoutContainerRecipe,
  link: linkRecipe,
  separator: separatorRecipe,
  skeleton: skeletonRecipe,
  spinner: spinnerRecipe,
};

export default basicRecipes;
